import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule,  MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-new-claim-save-draft-dialog',
  templateUrl: './new-claim-save-draft-dialog.component.html',
  styleUrls: ['./new-claim-save-draft-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatDialogModule, 
    MatButtonModule
  ]
})
export class NewClaimSaveDraftDialogComponent {

  constructor(public dialogRef: MatDialogRef<NewClaimSaveDraftDialogComponent>) {}

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}